import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=db086196&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=db086196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db086196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db086196')) {
      api.createRecord('db086196', component.options)
    } else {
      api.reload('db086196', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=db086196&scoped=true&", function () {
      api.rerender('db086196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vqjkmH0qoVCu/JS/comp/GuestBox.vue"
export default component.exports